import { NAVIGATION_APIS } from "libs/apis/navigation.api";
import { useNavigate } from "react-router-dom";


const useNavigations = () => {
  const navigate = useNavigate();

  const readNotification = async () => {
    const response = await NAVIGATION_APIS.readNotification();
    const { status = false, message = "" } = response || {};
    if (status) {
      // successToaster(message);
    }
  };

  const getNotificationCount = async (setData: Function) => {
    const response = await NAVIGATION_APIS.getNotificationCount();
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  return {
    readNotification,
    getNotificationCount,
  };
};

export default useNavigations;
